'use client'

import { cx } from '@7f-ui'
import { BaseButton } from '@7f-ui/components/button/button'
import type { MerchantObject } from '@data-access/graphql/schema.types'

import { shopTestId } from '@utils/utils-shop-test-ids'
import { useState } from 'react'

import type { MerchantModalProps } from './merchant-modal'
import { MerchantModal } from './merchant-modal'

export interface MerchantDetailsProps {
  merchant: (Pick<MerchantObject, 'tradeName'> & MerchantModalProps['merchant']) | null
  className?: string
  onShowImprint?: () => void
}

export function MerchantDetails({ merchant, className, onShowImprint }: MerchantDetailsProps) {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <BaseButton
        onClick={() => (onShowImprint ? onShowImprint() : setShowModal(true))}
        // z-10 keeps this above the Partnerbox overlay in
        // app-experience-merchant-profile, which would otherwise swallow the click.
        className={cx('relative z-10 mt-2 text-left font-body-small text-link', className)}
        data-testid={shopTestId('MerchantDetails.open-modal-action')}
      >
        Impressum
      </BaseButton>

      <MerchantModal merchant={merchant} show={showModal} onClose={() => setShowModal(false)} />
    </>
  )
}
